/** Body text — sidebar nav, main content, header menus */
export const TYPO_BODY = 'sm'

/** Secondary labels — header breadcrumb, captions, table headers */
export const TYPO_CAPTION = 'xs'

/** Section / page titles — header bar title */
export const TYPO_TITLE = 'md'
